import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 750px;
  align-items: center;
`;

export const Container = styled.header`
  z-index: 21;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1em;
  padding: 0 1em;
  border-bottom: 1px solid ${Colors.shade06};
  background-color: ${Colors.shade08};
  //position: relative;
  min-height: 70px;
  position: sticky;
  top: 0;
`;
